import GoogleOauth from "../Oauth/GoogleOauth"


const GoogleLogIn = () => {

  return (
    <GoogleOauth />
  );
};

export default GoogleLogIn;
